export default "__VITE_ASSET__CqPTxEr8__"